import { LOCAL_STORAGE_ACCESS_KEYS } from "@constant";

export var loadState = () => {
  try {
    var serializedState = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEYS.state);
    if (serializedState === null) {
      return undefined;
    } else {
      return JSON.parse(serializedState);
    }
  } catch (err) {
    return undefined;
  }
};

export var saveState = (state) => {
  try {
    //Choose what we need to save in local storage to handle refresh
    var stateToSave = {
      isLoggedIn: state.isLoggedIn,
      session: state.session,
    };
    var serializedState = JSON.stringify(stateToSave);
    localStorage.setItem("state", serializedState);
  } catch (err) {}
};

export var reset = () => {
  try {
    localStorage.clear();
  } catch (err) {}
};

export const loadFromLocalDB = (key) => {
  try {
    let localData = localStorage.getItem(key);
    if (localData !== null) {
      return JSON.parse(localData);
    } else return undefined;
  } catch (error) {
    return undefined;
  }
};

export const setInLocalDB = (data) => {
  let serializedState = JSON.stringify(data.value);
  localStorage.setItem(data.key, serializedState);
};
